import Section from "../Section/Section";
import Banner from "./DialogBanner";
import Body from "./DialogBody";
import Footer from "./DialogFooter";
import Frame from "./DialogFrame";
import Header, { Subtitle, Title } from "./DialogHeader";
import Legend from "./DialogLegend";
import Stepper, { StepCounter } from "./DialogStepper";
export default {
    Frame,
    Header,
    Title,
    Subtitle,
    Stepper,
    StepCounter,
    Banner,
    Body,
    Section,
    Legend,
    Footer,
};
//# sourceMappingURL=Dialog.js.map